import Tabs, {SELECTORS as TABS_SELECTORS} from "../../../Components/Tabs/Tabs";

import '../../../Components/Tabs/_index.scss';
$(TABS_SELECTORS.root).each((i, tabs) => {
    new Tabs(tabs);
});
